import { Companion_getInstance2lw3j8toa9ha6 as Companion_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  toNotBlankString1ovj48s0kinvm as toNotBlankString,
  NotBlankString__toString_impl_5tex9r22pq2l6hpj9hd as NotBlankString__toString_impl_5tex9r,
  NotBlankString__hashCode_impl_fxqzj43axmbww1ctojf as NotBlankString__hashCode_impl_fxqzj4,
} from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import {
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqgfu6uyyvgx74d as _Result___get_value__impl__bjfvqg,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PinTarget_Pair_getInstance2rze6a7qwq9bk as PinTarget_Pair_getInstance } from './PinTarget.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      v29() {
        // Inline function 'kotlin.getOrThrow' call
        var this_0 = toNotBlankString(Companion_getInstance().qt().toString());
        throwOnFailure(this_0);
        var tmp$ret$0 = _Result___get_value__impl__bjfvqg(this_0).u28_1;
        return new (PinId())(tmp$ret$0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var PinIdClass;
function PinId() {
  if (PinIdClass === VOID) {
    class $ {
      constructor(value) {
        this.j2d_1 = value;
      }
      toString() {
        return 'PinId(value=' + NotBlankString__toString_impl_5tex9r(this.j2d_1) + ')';
      }
      hashCode() {
        return NotBlankString__hashCode_impl_fxqzj4(this.j2d_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinId()))
          return false;
        if (!(this.j2d_1 === other.j2d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinId');
    PinIdClass = $;
  }
  return PinIdClass;
}
var PinClass;
function Pin() {
  if (PinClass === VOID) {
    class $ {
      constructor(id, name, icon, target) {
        name = name === VOID ? '' : name;
        icon = icon === VOID ? '' : icon;
        target = target === VOID ? PinTarget_Pair_getInstance() : target;
        this.k2d_1 = id;
        this.l2d_1 = name;
        this.m2d_1 = icon;
        this.n2d_1 = target;
      }
      o2d(id, name, icon, target) {
        return new (Pin())(id, name, icon, target);
      }
      p2d(id, name, icon, target, $super) {
        id = id === VOID ? this.k2d_1 : id;
        name = name === VOID ? this.l2d_1 : name;
        icon = icon === VOID ? this.m2d_1 : icon;
        target = target === VOID ? this.n2d_1 : target;
        return $super === VOID ? this.o2d(id, name, icon, target) : $super.o2d.call(this, id, name, icon, target);
      }
      toString() {
        return 'Pin(id=' + this.k2d_1.toString() + ', name=' + this.l2d_1 + ', icon=' + this.m2d_1 + ', target=' + this.n2d_1.toString() + ')';
      }
      hashCode() {
        var result = this.k2d_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.l2d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m2d_1) | 0;
        result = imul(result, 31) + this.n2d_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Pin()))
          return false;
        if (!this.k2d_1.equals(other.k2d_1))
          return false;
        if (!(this.l2d_1 === other.l2d_1))
          return false;
        if (!(this.m2d_1 === other.m2d_1))
          return false;
        if (!this.n2d_1.equals(other.n2d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Pin');
    PinClass = $;
  }
  return PinClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  PinId as PinId3lhhfdu3qni8f,
  Pin as Pin34ndi4qc5y3vu,
  Companion_instance as Companion_instancekxxruz9vaoco,
};
//endregion

//# sourceMappingURL=Pin.mjs.map
